"use client";

import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function HeaderStrip() {
  const { t } = useLanguage();
  return (
    <div className="bg-[#047857] py-5 px-4 md:px-6">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <nav className="flex items-center gap-2 text-white text-sm">
          <Link to="/" className="hover:text-[#fbbf24] transition-colors">
            {t("nav.home")}
          </Link>
          <i className="ri-arrow-right-s-line text-white/60" />
          <span className="font-semibold">{t("access.h1")}</span>
        </nav>
        <span className="hidden md:block text-white/90 text-sm font-medium">
          {t("access.conformanceBadge")}
        </span>
      </div>
    </div>
  );
}